import React from 'react';

const TermsOfParticipation = {
    version: '1.0.0',
    element: (
        <div className={'justify-evenly'} data-testid="terms-of-participation">
            <p>
                D. E. Shaw & Co. (London), L.L.P. (including its employees and
                affiliates, “DESCO”) has developed its Industry Consultant
                Program (the “ICP”) to identify industry professionals and other
                experts whose specialized knowledge or experience may be useful
                in supplementing DESCO’s investment strategies and to arrange
                confidential consultations between such experts and DESCO’s
                research analysts for such purpose (“Consultations”). You have
                been invited to participate in the ICP as a potential consultant
                (“Consultant”) because of your expertise in a subject area in
                which DESCO is seeking to increase its knowledge base.
            </p>
            <br />
            <p>
                Your participation in the ICP, however, is subject to and
                conditioned upon your agreement to abide by the following terms
                of participation (“Terms of Participation”), which are designed
                to ensure compliance with all applicable laws, rules and
                regulations, and any obligations you may owe to third parties.
                By participating in the ICP, you are confirming that you have
                read, understand, and agree to be bound by these Terms of
                Participation. If you are unwilling or unable to abide by any
                term specified herein, you must refrain from participation in
                the ICP. From time to time, DESCO may require that you
                re-certify your understanding of and agreement to be bound by
                these Terms of Participation. Your failure to do so at any time
                will preclude your further participation in the ICP.
            </p>
            <br />
            <p>
                <b>Eligibility.</b> You are eligible to participate in the ICP
                only if your participation is permitted by, and does not violate
                any obligation you owe to, your employer, any company of which
                you are a director, any client of yours, and any other third
                party to whom you owe a legal or fiduciary obligation. By
                executing these Terms of Participation, you are representing
                that you have obtained any and all necessary consents and
                authorizations to participate in and be compensated for
                Consultations, and that you have reviewed all of your employment
                and/or consulting agreements (including employee manuals and
                codes of conduct) and these agreements do not prohibit your
                participation in the ICP or your receipt of any payment
                therefore. You agree that DESCO may confirm your procurement of
                the foregoing consents and authorizations with the relevant
                third parties. If your participation in the ICP would violate or
                conflict with (x) any obligation or duty you owe to your
                employer, any company of which you are a director, any client of
                yours, or any other third party, (y) any court order, or (z) any
                other legally binding obligation, you must not submit an
                application to become a Consultant or, if you are already a
                Consultant, you must withdraw from the ICP. You agree to notify
                DESCO immediately in writing if and to the extent you are no
                longer permitted to participate in the ICP. By acknowledging
                your acceptance of these Terms of Participation, you certify
                your eligibility to participate in the ICP.
            </p>
            <br />
            <p>
                <b>Applying to Become an ICP Consultant.</b> In order to become
                a Consultant in the ICP, you are required to provide DESCO with
                certain “personal data” about yourself, including your contact
                information, a current resumé / curriculum vitae, your complete
                employment history, your directorships and consulting history
                for the past six months, and certain other relevant background
                information. You agree that the personal data that you provide
                DESCO is true, supportable, accurate, and complete. You also
                agree to confirm the accuracy of and/or advise DESCO of any
                changes in such personal data (including, without limitation,
                any new employment or consulting relationships you may have with
                any organization) before accepting any Invitation (as defined
                below). In addition, you are required to deliver to DESCO an
                executed version of these Terms of Participation acknowledging
                your acceptance thereof. Your application will not be considered
                by DESCO until you have submitted all required materials.
            </p>
            <br />
            <p>
                You acknowledge that you have reviewed the European ICP Personal
                Data Privacy Notice (the “Privacy Notice”, may be found on the
                previous page of this application or by clicking the link at the
                bottom of this page), which describes the manner and purposes
                for which DESCO processes your personal data, and your rights
                over your personal data. You furthermore acknowledge that D. E.
                Shaw & Co., L.P., and D. E. Shaw & Co. (London), LLP, are
                controllers of your personal data in connection with ICP.
            </p>
            <br />
            <p>
                If you are not selected to participate in a Consultation at or
                shortly after the time that you apply to become a Consultant,
                your personal data will be kept on file by DESCO, and DESCO may
                contact you at a later date regarding other Consultations for
                which you may be qualified. You agree that DESCO may maintain
                the information you provide in the course of the application
                process and share it with its employees and affiliates. Unless
                required by law, regulation, or court order, DESCO will not
                share your personal data with any unaffiliated third party. You
                are free to terminate your participation in the ICP at any time
                by so notifying DESCO in writing and ask DESCO to delete your
                personal data as detailed in the Privacy Notice.
            </p>
            <br />
            <p>
                <b>Invitations to Participate in Consultations.</b> DESCO’s ICP
                manager will contact you if a DESCO research analyst requests
                your participation in a Consultation (an “Invitation”). The ICP
                manager will explain the subject matter of the Consultation and
                the general nature of the questions you will be asked. You are
                free to either accept or reject any Invitation. Nothing in these
                Terms of Participation imposes any obligation on DESCO to issue
                any Invitations. If you agree to participate in a Consultation,
                however, you agree that your participation will be in accordance
                with the highest ethical standards of your industry or
                profession, all applicable laws, rules, and regulations, your
                obligations and duties to your employer, any company of which
                you are a director, any client of yours, and any other third
                party to whom you owe a fiduciary obligation, and these Terms of
                Participation. You should either accept or reject an Invitation
                by the end of the business day following your receipt thereof,
                unless otherwise specified by DESCO in the Invitation. You
                understand and agree that all potential Consultations are
                subject to prior review by DESCO’s Compliance department and
                that DESCO Compliance personnel and/or other persons employed or
                retained by DESCO may silently monitor and/or record
                Consultations, in DESCO’s sole discretion.
            </p>
            <br />
            <p>
                <b>Obligations of Consultants; Prohibited Disclosures.</b> At no
                time during the course of your participation in the ICP or
                otherwise may you disclose to DESCO any (1) Material Nonpublic
                Information, (2) Confidential Information, or (3) Intellectual
                Property, as such terms are defined below, nor may you use
                Material Nonpublic Information, Confidential Information, or
                Intellectual Property in any way in your work for DESCO. If you
                are employed by or serve as a director of a company whose
                securities are publicly-traded, you may not discuss with DESCO
                any aspect of that company’s business or prospects.
            </p>
            <br />
            <p>
                <i>Material Nonpublic Information</i> is any information
                regarding a company whose securities are publicly-traded that
                (i) a reasonable investor would consider important in making an
                investment decision regarding such securities or is reasonably
                likely to have an effect upon the price of such securities and
                (ii) has not been effectively disclosed in a manner that insures
                its availability to the investing public or is not already known
                by the investing public. Examples of Material Nonpublic
                Information about a public company may include undisclosed or
                not-yet-disseminated information regarding its earnings,
                financial performance, or forecasts; any mergers, acquisitions,
                tender offers, or joint ventures involving the company;
                significant changes in its assets; its new products or
                discoveries; significant developments regarding its customers or
                suppliers; changes in its control or management; changes in its
                auditors or auditing practices; its bankruptcy or receivership;
                or any other event that is likely to affect the value of its
                securities.
            </p>
            <br />
            <p>
                <i>Confidential Information</i> is information that is subject
                to a duty of confidentiality you owe to a third party or is
                otherwise misappropriated by you (e.g., provided in violation of
                an employment agreement, fiduciary obligation, professional or
                other code of conduct, or confidentiality agreement; obtained
                through attendance at a closed Congressional hearing; offered in
                return for lavish gifts or entertainment; or procured through
                illegal means).
            </p>
            <br />
            <p>
                <i>Intellectual Property</i> is any work of authorship; idea,
                invention, patent, trade mark or trade name, service mark,
                registered design, design rights, copyright, database right,
                domain names, in each case whether registered or unregistered,
                or process; trade secret; know how; or proprietary information
                that is confidential or subject to a contractual obligation of
                nondisclosure or unauthorized use, regardless of whether the
                information is your property or that of some other individual or
                organization.
            </p>
            <br />
            <p>
                You agree that you will cooperate with DESCO and its authorized
                agents in any inquiry relating to your actual or potential
                disclosure of any Material Nonpublic Information, Confidential
                Information, or Intellectual Property.
            </p>
            <br />
            <p>
                <b>Use of Consultant-Provided Information.</b> You understand,
                acknowledge, and agree that the information you provide during a
                Consultation may be used by DESCO free of fee or royalty,
                worldwide and perpetually for whatever purposes DESCO, in its
                sole discretion, chooses, including trading on such information
                in the public securities markets and otherwise complementing its
                investment strategies. You agree that the information you
                provide will be true, supportable, accurate, and complete to the
                best of your knowledge. DESCO agrees that it will not
                communicate any of such information to unaffiliated third
                parties (except as may be required by law, regulation, or court
                order).
            </p>
            <br />
            <p>
                <b>Special Projects.</b> In the course of your participation in
                the ICP, you may be asked to perform additional services for
                DESCO, which may include the production of written reports or
                presentations. Should you accept any such special project, you
                agree that any right, title, or interest in any materials that
                you develop or produce for DESCO, including any intellectual
                property rights therein shall be and hereby are assigned to
                DESCO with full title guarantee and shall remain the sole and
                exclusive property of DESCO for all purposes and uses, and
                further that you shall have no right, title, or interest of any
                kind or nature therein, or in any of the results and/or proceeds
                obtained therefrom. Your additional fee for any such special
                project shall be separately negotiated with DESCO and may or may
                not reflect your standard fee rate for an ICP Consultation.
            </p>
            <br />
            <p>
                <b>Protection of DESCO Confidences.</b> In the course of and
                incident to your participation in the ICP, you may acquire
                valuable and competitively-sensitive proprietary information of
                DESCO’s regarding its current or prospective trading activities,
                investment strategies, or business operations. You agree that
                any such information belongs to DESCO. You agree that (1) you
                will maintain the confidentiality of the information and not use
                the information in any way for your own benefit or the benefit
                of any third party, and (2) you will not, directly or
                indirectly, at any time during your participation in the ICP or
                thereafter, use, disclose, or cause to be used or disclosed any
                information discussed or revealed during the course of a
                Consultation or otherwise acquired by you in connection with
                your participation in the ICP, including the subject matter of a
                Consultation, except as required by law or court order or as
                permitted by the last sentence of this section. Before complying
                with any legally binding request for disclosure of any such
                information, you agree to promptly notify DESCO thereof to the
                fullest extent permitted by law and thereafter to cooperate
                fully with DESCO in protecting such information to the extent
                legally possible. Except as aforesaid, you further agree that
                you will not disclose the fact that you are participating in the
                ICP or these Terms of Participation to any third party other
                than your employer, a company of which you are a director, or,
                solely for the purpose of obtaining their advice with respect to
                your participation in the ICP, your legal and financial
                advisers. Notwithstanding anything to the contrary in these
                Terms of Participation, you shall be free, without notice to
                DESCO, to communicate directly with and provide confidential
                information regarding DESCO, including documents, to any
                regulator or other competent supranational, national, federal,
                state, or local governmental agencies or commissions regarding
                possible violations of law or regulation.
            </p>
            <br />
            <p>
                <b>Relationship of the Parties.</b> You agree that your
                relationship with DESCO is solely that of an independent
                contractor. Unless otherwise specified by DESCO, each
                Consultation is a discrete, stand-alone engagement, and, though
                your agreement to abide by these Terms of Participation
                continues and binds you throughout your participation in the ICP
                and thereafter, your services on behalf of DESCO will terminate
                at the conclusion of each Consultation unless and until you are
                invited to participate in a subsequent Consultation. Nothing
                contained in these Terms of Participation, and no modification
                of your responsibilities or the terms of any fee/compensation
                made hereafter, shall be construed to change your status with
                DESCO. You agree that you are not an employee, worker, director,
                officer, member, partner, legal representative, or agent of
                DESCO for any purpose whatsoever and that at no time will you
                hold yourself out as such. You are not entitled to any benefit
                provided by DESCO to its employees and DESCO shall not make any
                deductions from payments to you to account for your tax
                liability. You will be personally responsible for any and all
                taxes, National Insurance / social security or other
                contributions which are or may be payable out of, or as result
                of the receipt of, any fees or other monies paid or payable to
                you by DESCO.
            </p>
            <br />
            <p>
                <b>Fee.</b> Your fee for a Consultation will be based on the
                amount of time you spend during the Consultation and the
                customary hourly rate for an expert with similar expertise and
                experience to yours. The applicable fee rate shall be agreed
                upon by you and DESCO in writing in advance of any Consultation.
                Reimbursement for reasonable ICP-related expenses including
                travel is permitted only with prior written approval from DESCO
                and upon documentation by you of all such expenses in such
                detail as shall be satisfactory to DESCO in its sole discretion.
                In the event you do not obtain prior written approval from DESCO
                or provide DESCO with satisfactory documentation of expenses,
                DESCO shall not have any obligation (under these Terms of
                Participation or otherwise) to reimburse you for such expenses.
                Upon the completion of each Consultation, you shall promptly
                submit an invoice to DESCO covering the agreed-upon fees and
                approved expenses which will be paid to you within thirty (30)
                days thereafter. The fees and expenses described in this section
                shall be the exclusive fee due to you from DESCO during or on
                account of the Consultation.
            </p>
            <br />
            <p>
                <b>Indemnification.</b> You agree to indemnify, defend, and hold
                harmless DESCO against (i) any action by a third party in
                connection with an alleged disclosure by you of Material
                Nonpublic Information, Confidential Information, or Intellectual
                Property or in connection with an alleged breach of fiduciary
                duty owed by you to your employer, any company of which you are
                a director, any client of yours, or any other third party; (ii)
                any assertion by you, or finding, that you are in reality an
                employee or worker of DESCO, (iii) for any negligence on your
                part in providing the services under these Terms of
                Participation, and (iv) in respect of any tax liability (or
                social security or similar levy) in respect of fee/compensation
                paid by DESCO for your services. You confirm that your services
                hereunder are covered by a policy of liability insurance.
            </p>
            <br />
            <p>
                <b>Limitation of Liability.</b> You agree that in no event
                whatsoever shall DESCO be liable to you or any other party, in
                contract, tort (including negligence), statutory duty,
                pre-contract or other representations (other than fraudulent
                misrepresentations) or otherwise arising out of or in connection
                with these Terms of Participation for: (a) consequential,
                indirect or special loss or damage; or (b) any loss of goodwill
                or reputation; or (c) any economic losses (including loss of
                revenues, profits, contracts, business or anticipated savings)
                resulting from your participation in the ICP or any
                Consultation.
            </p>
            <br />
            <p>
                DESCO’s maximum liability in contract, tort (including
                negligence), statutory duty, pre-contract or other
                representations (other than fraudulent or negligent
                misrepresentations) or otherwise arising out of or in connection
                with these Terms of Participation shall not exceed the sums paid
                for the Consultation by DESCO or £500, whichever is the greater.
            </p>
            <br />
            <p>
                Nothing in these Terms of Participation shall exclude or limit
                liability for death or personal injury resulting from the
                negligence of either party or their servants, agents or
                employees acting in the course of their duties.
            </p>
            <br />
            <p>
                <b>Entire Agreement.</b> These Terms of Participation, which
                incorporate your completed application to participate in the
                ICP, constitute the entire agreement between you and DESCO and
                shall supersede any and all existing agreements between you and
                DESCO relating to the subject matter hereof. You acknowledge
                that in choosing to accept these Terms of Participation, you
                have not relied on any warranties, representations, or promises
                by DESCO, its employees, or any other parties except as
                specifically set forth herein or made fraudulently.
            </p>
            <br />
            <p>
                <b>Severability.</b> In the event that any of these Terms of
                Participation are determined by any competent authority to be
                invalid or unenforceable to any extent, such term shall to that
                extent be severed from the body of these Terms of Participation
                which shall continue to be valid and enforceable to the fullest
                extent permitted by law.
            </p>
            <br />
            <p>
                <b>Rights of Third Parties</b> Nothing in these Terms of
                Participation shall create or confer any rights or other
                benefits whether pursuant to the Contracts (Rights of Third
                Parties) Act 1999 or otherwise in favour of any person other
                than the parties to these Terms of Participation.
            </p>
            <br />
            <p>
                <b>Governing Law and Venue Restriction.</b> Any dispute arising
                out of your participation in the ICP shall be governed by, and
                construed in accordance with, the laws of England and Wales,
                without regard to conflicts-of-law principles. The parties
                hereby agree that the exclusive venue for resolving any disputes
                arising under these Terms of Participation shall be any court of
                competent jurisdiction located in England.
            </p>
        </div>
    ),
};

export default TermsOfParticipation;
